import { FeatureInfo } from "@/components/FeatureInfo";

export default function BacktestingPublic() {
  return (
    <FeatureInfo
      eyebrow="Backtesting"
      title="Test strategies before you trade them"
      subtitle="Run a strategy across historical demo data and review the equity curve, win rate, maximum drawdown, profit factor and per-trade statistics. Past performance does not guarantee future results."
      ctaLabel="Open Backtesting"
      ctaTo="/app/backtesting"
      note
      points={[
        { title: "Equity curve", desc: "Visualise how a strategy would have grown or drawn down over the test window." },
        { title: "Full metrics", desc: "Total trades, wins, losses, win rate, net return, drawdown, profit factor and more." },
        { title: "Configurable risk", desc: "Set risk per trade (0.25%–2%) and see how it changes the equity path." },
        { title: "Best & worst trades", desc: "Identify outliers so you understand the distribution of outcomes." },
      ]}
    />
  );
}
